<template>
    <FormCard>
        <template #cardTitle>
            Select the clinic for your Annual Check-Up
        </template>
        <template #cardSubtitle>
            You may only have your Annual Check-Up on select providers. If you need to have your Annual Check-Up on other providers, please contact <a href="https://www.hmi.com.ph/contact">HMI</a>.
        </template>
        <template #cardText>
            <!-- Regions -->
            <v-autocomplete
                v-if="getACUClinics && getACUClinics.ALL_CLINICS === true"
                v-model="location.region"
                color="teal"
                label="Region"
                :items="getToRegions"
                item-text="city_region"
                item-value="city_region"
                autocomplete="nope"
                auto-select-first
                @change="
                    (location.city=''),
                    (location.province=''),
                    (location.facility=''),
                    toProvinces({ REGION: location.region }),
                    additionalClinics({
                        MEMBN: $cookies.get('usermembn'),
                        FILTER: {
                            REGION: location.region,
                            PROVINCE: '',
                            CITY: ''
                        }
                    })"
            />
            <!-- Provinces -->
            <v-autocomplete
                v-if="getACUClinics && getACUClinics.ALL_CLINICS === true"
                v-model="location.province"
                color="teal"
                label="Province"
                :items="getToProvinces"
                item-text="city_province"
                item-value="city_province"
                autocomplete="nope"
                auto-select-first
                @change="
                    (location.city=''),
                    (data.facility=''),
                    toCities({ REGION: location.region, PROVINCE: location.province }),
                    additionalClinics({
                        MEMBN: $cookies.get('usermembn'),
                        FILTER: {
                            REGION: location.region,
                            PROVINCE: location.province,
                            CITY: ''
                        }
                    })"
            />
            <!-- Cities -->
            <v-autocomplete
                v-if="getACUClinics && getACUClinics.ALL_CLINICS === true"
                v-model="location.city"
                color="teal"
                label="City"
                :items="getToCities"
                item-text="city_name"
                item-value="city_province"
                autocomplete="nope"
                auto-select-first
                @change="
                    (data.facility=''),
                    additionalClinics({
                        MEMBN: $cookies.get('usermembn'),
                        FILTER: {
                            REGION: location.region,
                            PROVINCE: location.province,
                            CITY: location.city
                        }
                    })"
            />
            <!-- Facilities -->
            <v-autocomplete
                v-model="data.facility"
                color="teal"
                label="Name of Hospital/Clinic"
                :items="getToFacilitiesSorted"
                :rules="rules.fieldRules"
                item-text="hosp_name"
                autocomplete="nope"
                auto-select-first
                return-object
            />
            <v-menu
                v-model="data.menu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
            >
                <template #activator="{ on, attrs }">
                    <v-text-field
                        v-model="data.selectedDate"
                        label="Select your preferred date"
                        :prepend-inner-icon="mdiCalendar"
                        readonly
                        :rules="rules.date"
                        v-bind="attrs"
                        color="teal"
                        v-on="on"
                    />
                </template>
                <v-date-picker
                    v-model="data.selectedDate"
                    :min="minDate"
                    :allowed-dates="isAllowedDate"
                    color="teal"
                    header-color="teal"
                    @input="data.menu=false"
                />
            </v-menu>
            <!-- Reason -->
            <v-text-field
                label="Reason for Consultation:"
                value="ANNUAL CHECK UP"
                color="teal"
                readonly
                autocomplete="nope"
            />
        </template>
    </FormCard>
</template>

<script>
import { mapGetters } from 'vuex'
import FormCard from './Other/FormCard.vue'
import { moment } from '../../../../utils/date-shim'
import { mdiCalendar } from '@mdi/js'
export default {
    components: {
        FormCard
    },
    props: ['data', 'location'],
    data() {
        return {
            mdiCalendar,
            minDate: moment().format('YYYY-MM-DD'),
            disabledDates: [], // Example of specific dates to disable
            rules: {
                fieldRules: [(v) => !!v || 'Name of Hospital/Clinic is required.'],
                date: [v=>!!v||'Date is required.']
            },
            getInfo: null
        }
    },

    computed: {
        ...mapGetters(['getACUClinics', 'getUserConsultInfo']),
        getToFacilitiesSorted: {
            get() {
                let facilities = (this.getACUClinics).ADDITIONAL_CLINICS
                if (facilities) {
                    facilities.sort((a, b) => {
                        if (a.hosp_name < b.hosp_name) {
                            return -1
                        } else if (a.hosp_name > b.hosp_name) {
                            return 1
                        } else {
                            return 0
                        }
                    })
                }
                return facilities
            }
        }
    },
    watch: {
        getUserConsultInfo(newVal) {
            this.getInfo = {
                ACCOUNT: newVal.ACCOUNT,
                EFF_DATE: moment(newVal.EFF_DATE).utcOffset('+0800').format('YYYY-MM-DD'),
                ACC_EXP: moment(newVal.ACC_EXP).utcOffset('+0800').format('YYYY-MM-DD'),
                PD_UNTIL: moment(newVal.PD_UNTIL).utcOffset('+0800').format('YYYY-MM-DD'),
                LAST_D: moment(newVal.LAST_D).utcOffset('+0800').format('YYYY-MM-DD'),
                MSU: newVal.MSU,
                STATUS: newVal.STATUS,
                NAME: newVal.NAME,
                SEX: newVal.SEX,
                DOB: moment(newVal.DOB).utcOffset('+0800').format('YYYY-MM-DD'),
                GRCP_D: moment(newVal.GRCP_D).utcOffset('+0800').format('YYYY-MM-DD'),
                STATUS_DATE: moment(newVal.STATUS_DATE).utcOffset('+0800').format('YYYY-MM-DD'),
                RAW_STATUS: newVal.RAW_STATUS,
                ACU_START: newVal.ACU_ACTIVE_START ? moment(newVal.ACU_ACTIVE_START).utcOffset('+0800').format('YYYY-MM-DD') : null,
                ACU_END: newVal.ACU_ACTIVE_UNTIL ? moment(newVal.ACU_ACTIVE_UNTIL).utcOffset('+0800').format('YYYY-MM-DD') : null
            }
        }
    },
    methods: {
        isAllowedDate(date) {
            // Disable Sunday (Sunday = 0)
            const day = moment(date).day()
            if (day === 0) return false

            // Disable specific dates
            if (this.disabledDates.includes(moment(date).format('YYYY-MM-DD'))) return false

            // Disable dates before today
            if (moment(date).isBefore(moment(this.minDate))) return false

            // Disable dates before the date interval set by ACU Team
            if (this.getInfo && this.getInfo.ACU_START && moment(date).isBefore(moment(this.getInfo.ACU_START))) return false

            // Disable dates after the date interval set by ACU Team
            if(this.getInfo && this.getInfo.ACU_END && moment(date).isAfter(moment(this.getInfo.ACU_END))) return false

            // Disable dates before EFF DATE
            if (this.getInfo && this.getInfo.EFF_DATE && moment(date).isBefore(moment(this.getInfo.EFF_DATE))) return false

            // Disable dates on and after CANCELLATION DATE
            if(String(this.getInfo.RAW_STATUS) !== 'A' && moment(date).isSameOrAfter(moment(this.getInfo.STATUS_DATE))) return false

            // Disable dates after ACC_EXP
            if (this.getInfo && this.getInfo.ACC_EXP && moment(date).isAfter(moment(this.getInfo.ACC_EXP))) return false

            // Disable Dates after Paid Until
            if (this.getInfo && this.getInfo.PD_UNTIL && moment(date).isAfter(moment(this.getInfo.PD_UNTIL))) {

                // Exempt dates that are included in either grace period or extension
                if (this.getInfo && this.getInfo.GRCP_D && moment(date).isSameOrBefore(moment(this.getInfo.GRCP_D))) {
                    return true
                } else {
                    // Disable all dates after paid until if there is no grace period or extension
                    return false
                }
            }

            // // Disable dates after LAST DATE
            // if (this.getInfo && this.getInfo.LAST_D && moment(date).isAfter(moment(this.getInfo.LAST_D))) return false

            // Allow all other dates
            return true
        }
    }
}
</script>
